import { useEffect, useState } from 'react';

export function useTheme() {
  const [userPref, setUserPref] = useState(() => localStorage.getItem('theme'));
  const [systemTheme, setSystemTheme] = useState(() =>
    window.matchMedia('(prefers-color-scheme: dark)').matches ? 'dark' : 'light'
  );

  useEffect(() => {
    const mq = window.matchMedia('(prefers-color-scheme: dark)');
    const handler = (e) => setSystemTheme(e.matches ? 'dark' : 'light');
    mq.addEventListener('change', handler);
    return () => mq.removeEventListener('change', handler);
  }, []);

  const effectiveTheme = userPref ?? systemTheme;

  // Always set data-theme so every component's html[data-theme] rules fire,
  // whether the theme comes from user preference or system preference.
  useEffect(() => {
    document.documentElement.setAttribute('data-theme', effectiveTheme);
  }, [effectiveTheme]);

  function toggleTheme() {
    const next = effectiveTheme === 'dark' ? 'light' : 'dark';
    setUserPref(next);
    localStorage.setItem('theme', next);
  }

  return { effectiveTheme, toggleTheme };
}
